import { render, staticRenderFns } from "./quesGuide1.vue?vue&type=template&id=bd221d28"
import script from "./quesGuide1.vue?vue&type=script&lang=js"
export * from "./quesGuide1.vue?vue&type=script&lang=js"
import style0 from "./quesGuide1.vue?vue&type=style&index=0&id=bd221d28&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports